import React, { useMemo, useState } from 'react';
import { Search, LayoutGrid, List, MessageSquare, AlertTriangle, Clock, CheckCircle2, XCircle, FileText, Download, MoreVertical, ShieldAlert, CreditCard, User, Calendar, ChevronDown, CheckSquare, Square, AlertCircle } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Pagination } from '../ui/Pagination';
interface OrdersTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
type OrderStatus = 'new' | 'progress' | 'awaiting' | 'overdue' | 'completed' | 'cancelled';
interface Order {
  id: number;
  status: OrderStatus;
  title: string;
  client: string;
  price: number;
  priceFormatted: string;
  time: string;
  deadline: string;
  deadlineDate: string;
  paymentStatus: 'paid' | 'pending' | 'refunded';
  format: 'video' | 'chat';
  source: 'search' | 'ads' | 'referral' | 'direct';
  hasChat: boolean;
  unreadMessages: number;
  hasComplaint: boolean;
  hasRefund: boolean;
  hasFiles: boolean;
  responseTimer: string | null;
  packageInfo?: {
    name: string;
    remaining: number;
  };
}
const generateMockOrders = (): Order[] => [{
  id: 1050,
  status: 'new',
  title: 'Натальная карта (Видео)',
  client: 'Мария В.',
  price: 5000,
  priceFormatted: '5 000 ₽',
  time: '10 мин назад',
  deadline: '',
  deadlineDate: '',
  paymentStatus: 'paid',
  format: 'video',
  source: 'search',
  hasChat: false,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: '1ч 50мин',
  packageInfo: {
    name: 'Pro Pack 50',
    remaining: 31
  }
}, {
  id: 1049,
  status: 'new',
  title: 'Синастрия (Чат)',
  client: 'Дмитрий Р.',
  price: 4500,
  priceFormatted: '4 500 ₽',
  time: '2 часа назад',
  deadline: '',
  deadlineDate: '',
  paymentStatus: 'pending',
  format: 'chat',
  source: 'ads',
  hasChat: true,
  unreadMessages: 1,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: '10ч 15мин'
}, {
  id: 1048,
  status: 'new',
  title: 'Детский гороскоп',
  client: 'Елена С.',
  price: 3500,
  priceFormatted: '3 500 ₽',
  time: '5 часов назад',
  deadline: '',
  deadlineDate: '',
  paymentStatus: 'paid',
  format: 'video',
  source: 'referral',
  hasChat: false,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: '19ч 00мин'
}, {
  id: 1047,
  status: 'progress',
  title: 'Соляр на год (PDF)',
  client: 'Анна К.',
  price: 4000,
  priceFormatted: '4 000 ₽',
  time: 'Вчера',
  deadline: 'Осталось 2 дня',
  deadlineDate: '20 Окт',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'search',
  hasChat: true,
  unreadMessages: 3,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: null
}, {
  id: 1046,
  status: 'progress',
  title: 'Натальная карта',
  client: 'Ольга П.',
  price: 5000,
  priceFormatted: '5 000 ₽',
  time: 'Вчера',
  deadline: 'Осталось 5 часов',
  deadlineDate: '18 Окт',
  paymentStatus: 'paid',
  format: 'video',
  source: 'direct',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1045,
  status: 'progress',
  title: 'Прогноз транзитов',
  client: 'Игорь М.',
  price: 3000,
  priceFormatted: '3 000 ₽',
  time: '2 дня назад',
  deadline: 'Завтра',
  deadlineDate: '19 Окт',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'ads',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: null
}, {
  id: 1044,
  status: 'progress',
  title: 'Синастрия',
  client: 'Светлана Д.',
  price: 6000,
  priceFormatted: '6 000 ₽',
  time: '3 дня назад',
  deadline: 'Осталось 4 дня',
  deadlineDate: '22 Окт',
  paymentStatus: 'paid',
  format: 'video',
  source: 'search',
  hasChat: false,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1043,
  status: 'awaiting',
  title: 'Разбор финансов',
  client: 'Виктор Т.',
  price: 4500,
  priceFormatted: '4 500 ₽',
  time: '3 дня назад',
  deadline: 'Пауза',
  deadlineDate: '-',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'referral',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1042,
  status: 'awaiting',
  title: 'Натальная карта',
  client: 'Юлия Б.',
  price: 5000,
  priceFormatted: '5 000 ₽',
  time: '4 дня назад',
  deadline: 'Пауза',
  deadlineDate: '-',
  paymentStatus: 'pending',
  format: 'video',
  source: 'search',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1041,
  status: 'overdue',
  title: 'Соляр на год',
  client: 'Максим В.',
  price: 4000,
  priceFormatted: '4 000 ₽',
  time: '5 дней назад',
  deadline: 'Просрочено на 1 день',
  deadlineDate: '16 Окт',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'ads',
  hasChat: true,
  unreadMessages: 2,
  hasComplaint: true,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1040,
  status: 'overdue',
  title: 'Детский гороскоп',
  client: 'Татьяна Н.',
  price: 3500,
  priceFormatted: '3 500 ₽',
  time: 'Неделю назад',
  deadline: 'Просрочено на 3 часа',
  deadlineDate: '17 Окт',
  paymentStatus: 'paid',
  format: 'video',
  source: 'direct',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: false,
  responseTimer: null
}, {
  id: 1039,
  status: 'completed',
  title: 'Натальная карта',
  client: 'Елена Т.',
  price: 5000,
  priceFormatted: '5 000 ₽',
  time: '10 Окт',
  deadline: 'Завершен',
  deadlineDate: '12 Окт',
  paymentStatus: 'paid',
  format: 'video',
  source: 'search',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: null
}, {
  id: 1038,
  status: 'completed',
  title: 'Синастрия',
  client: 'Павел М.',
  price: 6000,
  priceFormatted: '6 000 ₽',
  time: '08 Окт',
  deadline: 'Завершен',
  deadlineDate: '10 Окт',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'referral',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: null
}, {
  id: 1037,
  status: 'completed',
  title: 'Прогноз на месяц',
  client: 'Алина К.',
  price: 2000,
  priceFormatted: '2 000 ₽',
  time: '05 Окт',
  deadline: 'Завершен',
  deadlineDate: '06 Окт',
  paymentStatus: 'paid',
  format: 'chat',
  source: 'ads',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: false,
  hasRefund: false,
  hasFiles: true,
  responseTimer: null
}, {
  id: 1036,
  status: 'cancelled',
  title: 'Соляр на год',
  client: 'Роман Д.',
  price: 4000,
  priceFormatted: '4 000 ₽',
  time: '01 Окт',
  deadline: 'Отменен',
  deadlineDate: '-',
  paymentStatus: 'refunded',
  format: 'video',
  source: 'search',
  hasChat: true,
  unreadMessages: 0,
  hasComplaint: true,
  hasRefund: true,
  hasFiles: false,
  responseTimer: null
}];
export function OrdersTab({
  showToast,
  setActiveTab
}: OrdersTabProps) {
  const [orders, setOrders] = useState<Order[]>(generateMockOrders());
  const [statusFilter, setStatusFilter] = useState<OrderStatus | 'all'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState<'cards' | 'table'>('cards');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrders, setSelectedOrders] = useState<Set<number>>(new Set());
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const ITEMS_PER_PAGE = 10;
  // Derived state
  const filteredOrders = useMemo(() => {
    return orders.filter(o => {
      const matchesStatus = statusFilter === 'all' || o.status === statusFilter;
      const matchesSearch = o.client.toLowerCase().includes(searchQuery.toLowerCase()) || o.id.toString().includes(searchQuery) || o.title.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesStatus && matchesSearch;
    });
  }, [orders, statusFilter, searchQuery]);
  const paginatedOrders = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredOrders.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredOrders, currentPage]);
  const totalPages = Math.ceil(filteredOrders.length / ITEMS_PER_PAGE);
  const counts = useMemo(() => {
    return {
      all: orders.length,
      new: orders.filter(o => o.status === 'new').length,
      progress: orders.filter(o => o.status === 'progress').length,
      awaiting: orders.filter(o => o.status === 'awaiting').length,
      overdue: orders.filter(o => o.status === 'overdue').length,
      completed: orders.filter(o => o.status === 'completed').length,
      cancelled: orders.filter(o => o.status === 'cancelled').length
    };
  }, [orders]);
  // Handlers
  const handleOrderAction = (orderId: number, action: string) => {
    setOrders(prev => prev.map(o => {
      if (o.id !== orderId) return o;
      switch (action) {
        case 'accept':
          showToast('Заказ взят в работу');
          return {
            ...o,
            status: 'progress',
            deadline: 'Осталось 3 дня',
            deadlineDate: 'Скоро',
            responseTimer: null
          };
        case 'reject':
          showToast('Заказ отклонен');
          return {
            ...o,
            status: 'cancelled',
            paymentStatus: 'refunded',
            deadline: 'Отменен'
          };
        case 'complete':
          showToast('Заказ успешно завершен');
          return {
            ...o,
            status: 'completed',
            deadline: 'Завершен',
            deadlineDate: 'Сегодня'
          };
        default:
          return o;
      }
    }));
  };
  const toggleSelection = (id: number) => {
    const newSet = new Set(selectedOrders);
    if (newSet.has(id)) newSet.delete(id);else newSet.add(id);
    setSelectedOrders(newSet);
  };
  const toggleAllSelection = () => {
    if (selectedOrders.size === paginatedOrders.length) {
      setSelectedOrders(new Set());
    } else {
      setSelectedOrders(new Set(paginatedOrders.map(o => o.id)));
    }
  };
  const handleMassAction = (action: string) => {
    showToast(`Применено к ${selectedOrders.size} заказам`);
    setSelectedOrders(new Set());
  };
  // Helpers
  const getStatusBadge = (status: OrderStatus) => {
    switch (status) {
      case 'new':
        return <Badge variant="warning" size="sm" data-id="element-13991">
            Новый
          </Badge>;
      case 'progress':
        return <Badge variant="pro" size="sm" data-id="element-13992">
            В работе
          </Badge>;
      case 'awaiting':
        return <Badge variant="neutral" size="sm" data-id="element-13993">
            Ждет ответа
          </Badge>;
      case 'overdue':
        return <Badge variant="error" size="sm" data-id="element-13994">
            Просрочен
          </Badge>;
      case 'completed':
        return <Badge variant="success" size="sm" data-id="element-13995">
            Завершен
          </Badge>;
      case 'cancelled':
        return <Badge variant="neutral" size="sm" data-id="element-13996">
            Отменен
          </Badge>;
    }
  };
  const getStatusColor = (status: OrderStatus) => {
    switch (status) {
      case 'new':
        return 'border-l-amber-500';
      case 'progress':
        return 'border-l-indigo-500';
      case 'awaiting':
        return 'border-l-blue-400';
      case 'overdue':
        return 'border-l-rose-500';
      case 'completed':
        return 'border-l-emerald-500';
      case 'cancelled':
        return 'border-l-slate-300';
    }
  };
  return <div className="space-y-4 sm:space-y-6 animate-in fade-in duration-300 pb-20 lg:pb-0" data-id="element-13997">
      {/* 1. KPI METRIC CARDS */}
      <div className="flex overflow-x-auto pb-2 sm:pb-0 sm:grid sm:grid-cols-3 lg:grid-cols-6 gap-3 scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0" data-id="element-13998">
        {[{
        id: 'new',
        label: 'Новые',
        count: counts.new,
        color: 'text-amber-600',
        bg: 'bg-amber-50',
        border: 'border-amber-200',
        activeBorder: 'ring-2 ring-amber-500'
      }, {
        id: 'progress',
        label: 'В работе',
        count: counts.progress,
        color: 'text-indigo-600',
        bg: 'bg-indigo-50',
        border: 'border-indigo-200',
        activeBorder: 'ring-2 ring-indigo-500'
      }, {
        id: 'awaiting',
        label: 'Ждут ответа',
        count: counts.awaiting,
        color: 'text-blue-600',
        bg: 'bg-blue-50',
        border: 'border-blue-200',
        activeBorder: 'ring-2 ring-blue-500'
      }, {
        id: 'overdue',
        label: 'Просрочены',
        count: counts.overdue,
        color: 'text-rose-600',
        bg: 'bg-rose-50',
        border: 'border-rose-200',
        activeBorder: 'ring-2 ring-rose-500'
      }, {
        id: 'completed',
        label: 'Завершены',
        count: counts.completed,
        color: 'text-emerald-600',
        bg: 'bg-emerald-50',
        border: 'border-emerald-200',
        activeBorder: 'ring-2 ring-emerald-500'
      }, {
        id: 'cancelled',
        label: 'Отменены',
        count: counts.cancelled,
        color: 'text-slate-600',
        bg: 'bg-slate-50',
        border: 'border-slate-200',
        activeBorder: 'ring-2 ring-slate-500'
      }].map(kpi => <div key={kpi.id} onClick={() => {
        setStatusFilter(statusFilter === kpi.id ? 'all' : kpi.id as OrderStatus);
        setCurrentPage(1);
      }} className={`flex-shrink-0 w-32 sm:w-auto flex flex-col p-3 rounded-xl border cursor-pointer transition-all hover:shadow-sm ${kpi.bg} ${kpi.border} ${statusFilter === kpi.id ? kpi.activeBorder : ''}`} data-id="element-13999">
            <span className="text-xs font-medium text-slate-600 mb-1" data-id="element-14000">
              {kpi.label}
            </span>
            <span className={`text-2xl font-bold ${kpi.color}`} data-id="element-14001">
              {kpi.count}
            </span>
          </div>)}
      </div>

      {/* 2. CONTROL PANEL */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 bg-white p-3 rounded-xl border border-slate-200 shadow-sm" data-id="element-14002">
        <div className="relative w-full sm:w-72" data-id="element-14003">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-14004" />
          <input type="text" placeholder="Поиск по ID, имени, услуге..." value={searchQuery} onChange={e => {
          setSearchQuery(e.target.value);
          setCurrentPage(1);
        }} className="w-full pl-9 pr-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-shadow" data-id="element-14005" />
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto justify-between sm:justify-end" data-id="element-14006">
          <Button variant="outline" size="sm" className="sm:hidden" icon={<Search className="w-4 h-4" data-id="element-14008" />} onClick={() => setIsMobileFilterOpen(true)} data-id="element-14007">
            Фильтры
          </Button>

          <div className="hidden sm:flex items-center gap-2" data-id="element-14009">
            <select className="text-sm border border-slate-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 text-slate-700" data-id="element-14010">
              <option data-id="element-14011">Сортировка: Сначала новые</option>
              <option data-id="element-14012">Сортировка: Сначала старые</option>
              <option data-id="element-14013">Сортировка: По дедлайну</option>
              <option data-id="element-14014">Сортировка: Сначала дорогие</option>
            </select>
          </div>

          <div className="flex items-center bg-slate-100 p-1 rounded-lg border border-slate-200 hidden lg:flex" data-id="element-14015">
            <button onClick={() => setViewMode('cards')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'cards' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500 hover:text-slate-700'}`} title="Вид карточками" data-id="element-14016">
              <LayoutGrid className="w-4 h-4" data-id="element-14017" />
            </button>
            <button onClick={() => setViewMode('table')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'table' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500 hover:text-slate-700'}`} title="Вид таблицей" data-id="element-14018">
              <List className="w-4 h-4" data-id="element-14019" />
            </button>
          </div>
        </div>
      </div>

      {/* EMPTY STATE */}
      {filteredOrders.length === 0 ? <Card padding="lg" className="text-center py-16 border-dashed border-2" data-id="element-14020">
          <Search className="w-12 h-12 text-slate-300 mx-auto mb-4" data-id="element-14021" />
          <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-14022">
            Заказы не найдены
          </h3>
          <p className="text-sm text-slate-500 mb-4" data-id="element-14023">
            Попробуйте изменить параметры поиска или фильтры
          </p>
          <Button variant="outline" onClick={() => {
        setStatusFilter('all');
        setSearchQuery('');
      }} data-id="element-14024">
            Сбросить фильтры
          </Button>
        </Card> : <>
          {/* 3. CARDS VIEW */}
          {viewMode === 'cards' && <div className="space-y-3" data-id="element-14025">
              {paginatedOrders.map(order => <Card key={order.id} padding="none" className={`border-l-4 overflow-visible transition-all hover:shadow-md ${getStatusColor(order.status)}`} data-id="element-14026">
                  <div className="p-3 sm:p-4 flex flex-col lg:flex-row gap-4" data-id="element-14027">
                    {/* Checkbox (Desktop) */}
                    <div className="hidden lg:flex items-start pt-1" data-id="element-14028">
                      <button onClick={() => toggleSelection(order.id)} className="text-slate-300 hover:text-indigo-500 transition-colors" data-id="element-14029">
                        {selectedOrders.has(order.id) ? <CheckSquare className="w-5 h-5 text-indigo-600" data-id="element-14030" /> : <Square className="w-5 h-5" data-id="element-14031" />}
                      </button>
                    </div>

                    {/* Main Info */}
                    <div className="flex-1 min-w-0" data-id="element-14032">
                      <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-14033">
                        {getStatusBadge(order.status)}
                        <span className="text-xs font-mono text-slate-400" data-id="element-14034">
                          #{order.id}
                        </span>
                        <span className="text-xs text-slate-500 hidden sm:inline" data-id="element-14035">
                          •
                        </span>
                        <span className="text-xs text-slate-500 flex items-center gap-1" data-id="element-14036">
                          <Clock className="w-3 h-3" data-id="element-14037" /> {order.time}
                        </span>

                        {/* Mobile Checkbox */}
                        <button onClick={() => toggleSelection(order.id)} className="lg:hidden ml-auto text-slate-300" data-id="element-14038">
                          {selectedOrders.has(order.id) ? <CheckSquare className="w-5 h-5 text-indigo-600" data-id="element-14039" /> : <Square className="w-5 h-5" data-id="element-14040" />}
                        </button>
                      </div>

                      <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-2" data-id="element-14041">
                        <h3 className="text-sm sm:text-base font-bold text-slate-900 truncate" data-id="element-14042">
                          {order.title}
                        </h3>
                        <span className="hidden sm:inline text-slate-300" data-id="element-14043">
                          |
                        </span>
                        <div className="flex items-center gap-1.5 text-sm text-slate-700" data-id="element-14044">
                          <User className="w-3.5 h-3.5 text-slate-400" data-id="element-14045" />
                          <span className="font-medium" data-id="element-14046">{order.client}</span>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-3 text-xs" data-id="element-14047">
                        <span className="font-bold text-slate-900" data-id="element-14048">
                          {order.priceFormatted}
                        </span>

                        {order.packageInfo && <Badge variant="pro" size="sm" className="text-[10px] bg-indigo-50 text-indigo-700 border-indigo-200" data-id="element-14049">
                            Из пакета: {order.packageInfo.name} (остаток:{' '}
                            {order.packageInfo.remaining})
                          </Badge>}

                        {order.paymentStatus === 'paid' ? <span className="text-emerald-600 flex items-center gap-1" data-id="element-14050">
                            <CheckCircle2 className="w-3 h-3" data-id="element-14051" /> Оплачено
                          </span> : order.paymentStatus === 'pending' ? <span className="text-amber-600 flex items-center gap-1" data-id="element-14052">
                            <Clock className="w-3 h-3" data-id="element-14053" /> Ждет оплаты
                          </span> : <span className="text-rose-600 flex items-center gap-1" data-id="element-14054">
                            <XCircle className="w-3 h-3" data-id="element-14055" /> Возврат
                          </span>}

                        <Badge variant="neutral" size="sm" className="text-[10px] uppercase tracking-wider hidden sm:inline-flex" data-id="element-14056">
                          {order.source === 'search' ? 'Поиск' : order.source === 'ads' ? 'Реклама' : order.source === 'referral' ? 'По ссылке' : 'Прямой'}
                        </Badge>
                      </div>
                    </div>

                    {/* Timers & Risks */}
                    <div className="flex flex-row lg:flex-col items-center lg:items-end justify-between lg:justify-center gap-2 lg:w-48 bg-slate-50 lg:bg-transparent p-2 lg:p-0 rounded-lg lg:rounded-none mt-3 lg:mt-0" data-id="element-14057">
                      {/* Timers */}
                      {order.status === 'new' && order.responseTimer && <div className="text-xs font-bold text-amber-600 flex items-center gap-1 bg-amber-100/50 px-2 py-1 rounded-md" data-id="element-14058">
                          <Clock className="w-3.5 h-3.5" data-id="element-14059" /> Ответьте за{' '}
                          {order.responseTimer}
                        </div>}

                      {order.status === 'progress' && <div className="text-xs font-medium text-slate-600 flex items-center gap-1" data-id="element-14060">
                          <Calendar className="w-3.5 h-3.5 text-slate-400" data-id="element-14061" />{' '}
                          {order.deadline}
                        </div>}

                      {order.status === 'overdue' && <div className="text-xs font-bold text-rose-600 flex items-center gap-1 bg-rose-100/50 px-2 py-1 rounded-md" data-id="element-14062">
                          <AlertTriangle className="w-3.5 h-3.5" data-id="element-14063" />{' '}
                          {order.deadline}
                        </div>}

                      {/* Risk Indicators */}
                      <div className="flex items-center gap-1.5" data-id="element-14064">
                        {order.paymentStatus === 'pending' && <div className="w-6 h-6 rounded-full bg-rose-50 flex items-center justify-center text-rose-500" title="Не оплачено" data-id="element-14065">
                            <CreditCard className="w-3.5 h-3.5" data-id="element-14066" />
                          </div>}
                        {order.hasChat && <div className={`relative w-6 h-6 rounded-full flex items-center justify-center cursor-pointer transition-colors ${order.unreadMessages > 0 ? 'bg-blue-100 text-blue-600 hover:bg-blue-200' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`} onClick={() => setActiveTab('chat')} title="Чат с клиентом" data-id="element-14067">
                            <MessageSquare className="w-3.5 h-3.5" data-id="element-14068" />
                            {order.unreadMessages > 0 && <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-rose-500 text-white text-[8px] font-bold rounded-full flex items-center justify-center border border-white" data-id="element-14069">
                                {order.unreadMessages}
                              </span>}
                          </div>}
                        {order.hasComplaint && <div className="w-6 h-6 rounded-full bg-rose-100 flex items-center justify-center text-rose-600" title="Жалоба" data-id="element-14070">
                            <ShieldAlert className="w-3.5 h-3.5" data-id="element-14071" />
                          </div>}
                        {order.hasFiles && <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center text-slate-600" title="Прикреплены файлы" data-id="element-14072">
                            <FileText className="w-3.5 h-3.5" data-id="element-14073" />
                          </div>}
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-wrap lg:flex-col gap-2 lg:w-40 justify-end mt-3 lg:mt-0 border-t lg:border-t-0 border-slate-100 pt-3 lg:pt-0" data-id="element-14074">
                      {order.status === 'new' && <>
                          <Button variant="primary" size="sm" className="flex-1 lg:w-full text-xs" onClick={() => handleOrderAction(order.id, 'accept')} data-id="element-14075">
                            Взять в работу
                          </Button>
                          <Button variant="outline" size="sm" className="flex-1 lg:w-full text-xs border-rose-200 text-rose-600 hover:bg-rose-50" onClick={() => handleOrderAction(order.id, 'reject')} data-id="element-14076">
                            Отклонить
                          </Button>
                        </>}

                      {order.status === 'progress' && <>
                          <Button variant="primary" size="sm" className="flex-1 lg:w-full text-xs bg-indigo-600 hover:bg-indigo-700" onClick={() => handleOrderAction(order.id, 'complete')} data-id="element-14077">
                            Завершить
                          </Button>
                          <Button variant="outline" size="sm" className="flex-1 lg:w-full text-xs" onClick={() => setActiveTab('chat')} data-id="element-14078">
                            Написать
                          </Button>
                        </>}

                      {order.status === 'awaiting' && <>
                          <Button variant="outline" size="sm" className="flex-1 lg:w-full text-xs" onClick={() => showToast('Напоминание отправлено')} data-id="element-14079">
                            Напомнить
                          </Button>
                        </>}

                      {order.status === 'overdue' && <>
                          <Button variant="primary" size="sm" className="flex-1 lg:w-full text-xs bg-rose-600 hover:bg-rose-700" onClick={() => handleOrderAction(order.id, 'complete')} data-id="element-14080">
                            Срочно сдать
                          </Button>
                          <Button variant="outline" size="sm" className="flex-1 lg:w-full text-xs" onClick={() => setActiveTab('chat')} data-id="element-14081">
                            Извиниться
                          </Button>
                        </>}

                      {order.status === 'completed' && <Button variant="outline" size="sm" className="flex-1 lg:w-full text-xs" icon={<Download className="w-3.5 h-3.5" data-id="element-14083" />} onClick={() => showToast('Скачивание...')} data-id="element-14082">
                          Скачать итог
                        </Button>}

                      {order.status === 'cancelled' && <Button variant="ghost" size="sm" className="flex-1 lg:w-full text-xs" onClick={() => setActiveTab('chat')} data-id="element-14084">
                          История чата
                        </Button>}
                    </div>
                  </div>
                </Card>)}
            </div>}

          {/* 4. TABLE VIEW (Desktop Only) */}
          {viewMode === 'table' && <div className="hidden lg:block" data-id="element-14085">
              <Card padding="none" className="overflow-hidden border-slate-200" data-id="element-14086">
                <div className="overflow-x-auto" data-id="element-14087">
                  <table className="w-full text-left text-sm" data-id="element-14088">
                    <thead className="bg-slate-50 border-b border-slate-200 text-slate-500 font-medium" data-id="element-14089">
                      <tr data-id="element-14090">
                        <th className="p-3 w-10 text-center" data-id="element-14091">
                          <button onClick={toggleAllSelection} className="text-slate-400 hover:text-indigo-600" data-id="element-14092">
                            {selectedOrders.size === paginatedOrders.length && paginatedOrders.length > 0 ? <CheckSquare className="w-4 h-4 text-indigo-600" data-id="element-14093" /> : <Square className="w-4 h-4" data-id="element-14094" />}
                          </button>
                        </th>
                        <th className="p-3" data-id="element-14095">ID</th>
                        <th className="p-3" data-id="element-14096">Клиент</th>
                        <th className="p-3" data-id="element-14097">Услуга</th>
                        <th className="p-3" data-id="element-14098">Цена</th>
                        <th className="p-3" data-id="element-14099">Статус</th>
                        <th className="p-3" data-id="element-14100">Дедлайн</th>
                        <th className="p-3 text-right" data-id="element-14101">Действия</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-14102">
                      {paginatedOrders.map(order => <tr key={order.id} className={`hover:bg-slate-50 transition-colors ${selectedOrders.has(order.id) ? 'bg-indigo-50/30' : ''}`} data-id="element-14103">
                          <td className="p-3 text-center" data-id="element-14104">
                            <button onClick={() => toggleSelection(order.id)} className="text-slate-300 hover:text-indigo-600" data-id="element-14105">
                              {selectedOrders.has(order.id) ? <CheckSquare className="w-4 h-4 text-indigo-600" data-id="element-14106" /> : <Square className="w-4 h-4" data-id="element-14107" />}
                            </button>
                          </td>
                          <td className="p-3 font-mono text-xs text-slate-500" data-id="element-14108">
                            #{order.id}
                          </td>
                          <td className="p-3 font-medium text-slate-900" data-id="element-14109">
                            {order.client}
                          </td>
                          <td className="p-3 text-slate-700" data-id="element-14110">{order.title}</td>
                          <td className="p-3" data-id="element-14111">
                            <div className="font-bold text-slate-900" data-id="element-14112">
                              {order.priceFormatted}
                            </div>
                            {order.packageInfo && <div className="text-[10px] text-indigo-600 font-medium mt-0.5" data-id="element-14113">
                                Из пакета (ост: {order.packageInfo.remaining})
                              </div>}
                          </td>
                          <td className="p-3" data-id="element-14114">
                            {getStatusBadge(order.status)}
                          </td>
                          <td className="p-3 text-xs text-slate-600" data-id="element-14115">
                            {order.status === 'new' ? <span className="text-amber-600 font-bold" data-id="element-14116">
                                {order.responseTimer}
                              </span> : order.deadline}
                          </td>
                          <td className="p-3 text-right" data-id="element-14117">
                            <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={() => setActiveTab('chat')} data-id="element-14118">
                              <MoreVertical className="w-4 h-4 text-slate-400" data-id="element-14119" />
                            </Button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>}

          {viewMode === 'table' && <div className="lg:hidden text-center py-8 text-slate-500 text-sm" data-id="element-14120">
              Табличный вид доступен только на больших экранах. Пожалуйста,
              используйте вид карточками.
            </div>}

          {/* 5. MASS ACTIONS BAR */}
          {selectedOrders.size > 0 && <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-slate-900 text-white px-4 py-3 rounded-2xl shadow-2xl flex items-center gap-4 animate-in slide-in-from-bottom-10" data-id="element-14121">
              <div className="flex items-center gap-2 border-r border-slate-700 pr-4" data-id="element-14122">
                <span className="w-6 h-6 rounded-full bg-indigo-500 flex items-center justify-center text-xs font-bold" data-id="element-14123">
                  {selectedOrders.size}
                </span>
                <span className="text-sm font-medium" data-id="element-14124">выбрано</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-14125">
                <Button variant="primary" size="sm" className="bg-indigo-500 hover:bg-indigo-400 border-none text-xs" onClick={() => handleMassAction('accept')} data-id="element-14126">
                  Взять в работу
                </Button>
                <Button variant="outline" size="sm" className="bg-transparent border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white text-xs" onClick={() => handleMassAction('export')} data-id="element-14127">
                  Экспорт CSV
                </Button>
                <button onClick={() => setSelectedOrders(new Set())} className="ml-2 text-slate-400 hover:text-white transition-colors" data-id="element-14128">
                  <XCircle className="w-5 h-5" data-id="element-14129" />
                </button>
              </div>
            </div>}

          {/* 8. PAGINATION */}
          {totalPages > 1 && <div className="pt-4 flex justify-center" data-id="element-14130">
              <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-14131" />
            </div>}
        </>}

      {/* 6. MOBILE FILTER PANEL */}
      {isMobileFilterOpen && <div className="fixed inset-0 z-50 flex sm:hidden" data-id="element-14132">
          <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" onClick={() => setIsMobileFilterOpen(false)} data-id="element-14133" />
          <div className="absolute right-0 top-0 bottom-0 w-[280px] bg-white shadow-2xl animate-in slide-in-from-right flex flex-col" data-id="element-14134">
            <div className="p-4 border-b border-slate-100 flex items-center justify-between" data-id="element-14135">
              <h3 className="font-bold text-slate-900" data-id="element-14136">Фильтры</h3>
              <button onClick={() => setIsMobileFilterOpen(false)} className="p-2 text-slate-400 hover:text-slate-600 bg-slate-50 rounded-full" data-id="element-14137">
                <XCircle className="w-5 h-5" data-id="element-14138" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-4 space-y-6" data-id="element-14139">
              <div data-id="element-14140">
                <label className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block" data-id="element-14141">
                  Статус
                </label>
                <select className="w-full border border-slate-200 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" value={statusFilter} onChange={e => setStatusFilter(e.target.value as OrderStatus | 'all')} data-id="element-14142">
                  <option value="all" data-id="element-14143">Все заказы</option>
                  <option value="new" data-id="element-14144">Новые</option>
                  <option value="progress" data-id="element-14145">В работе</option>
                  <option value="awaiting" data-id="element-14146">Ждут ответа</option>
                  <option value="overdue" data-id="element-14147">Просрочены</option>
                  <option value="completed" data-id="element-14148">Завершены</option>
                </select>
              </div>
              <div data-id="element-14149">
                <label className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block" data-id="element-14150">
                  Сортировка
                </label>
                <select className="w-full border border-slate-200 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none" data-id="element-14151">
                  <option data-id="element-14152">Сначала новые</option>
                  <option data-id="element-14153">По дедлайну</option>
                  <option data-id="element-14154">Сначала дорогие</option>
                </select>
              </div>
              <div data-id="element-14155">
                <label className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block" data-id="element-14156">
                  Тип услуги
                </label>
                <div className="space-y-2" data-id="element-14157">
                  {['Натальная карта', 'Соляр', 'Синастрия', 'Прогноз'].map(s => <label key={s} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-14158">
                        <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500" data-id="element-14159" />{' '}
                        {s}
                      </label>)}
                </div>
              </div>
            </div>
            <div className="p-4 border-t border-slate-100 bg-slate-50 flex gap-2" data-id="element-14160">
              <Button variant="outline" className="flex-1" onClick={() => {
            setStatusFilter('all');
            setIsMobileFilterOpen(false);
          }} data-id="element-14161">
                Сбросить
              </Button>
              <Button variant="primary" className="flex-1" onClick={() => setIsMobileFilterOpen(false)} data-id="element-14162">
                Применить
              </Button>
            </div>
          </div>
        </div>}
    </div>;
}